export const cartSummaryStyles = {
  root: 'sticky top-4 rounded-lg border border-brand-700/20 bg-surface p-6',
  title: 'mb-4 font-heading text-heading-lg text-brand-950',
  rows: 'mb-4 space-y-2 font-sans text-brand-950',
  row: 'flex justify-between',
  totals: 'space-y-2 border-t border-brand-700/20 pt-2',
  totalRow: 'flex justify-between font-heading text-heading-md',
} as const;
